/**
 *  阅卷模块
 */
import http from '../assets/js/http'
import http2 from '../assets/js/http2'
// 阅卷列表
export const getList = (params) => { return http2.request({ url: '/markingPaper/getList', method: 'get', params: params }) }
// 未考考生列表
export const getWkList = (params) => { return http.request({ url: '/markingPaper/getWkList', method: 'get', params: params }) }
// 阅卷列表
export const getListData = (params) => { return http.request({ url: '/markingPaper/getListData', method: 'get', params: params }) }
// 考生重考
export const resit = (params) => { return http.request({ url: '/markingPaper/resit', method: 'post', params: params, headers: { 'Content-Type': 'application/json;charset=utf-8' } }) }
// 考生试卷内容
export const detail = (params) => { return http.request({ url: '/markingPaper/detail', method: 'get', params: params }) }
// 阅卷保存
export const save = (params) => { return http.request({ url: '/markingPaper/save', method: 'post', params: params, headers: { 'Content-Type': 'application/json;charset=utf-8' } }) }
